// TODO: refactoring - check if these types exists

export enum TRTCMode {
  LIVE = 'live',
  RTC = 'rtc',
}
